<template>
  <v-row class="fill-height">
    <v-col v-if="showChart">
      <Doughnut
        class="chart-container"
        :chartData="chartData"
        :chartOptions="chartOptions"
      />
    </v-col>
    <v-col v-else cols="12" class="d-flex align-center justify-center no-data">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex align-center justify-center">
          <v-icon class="mb-2 animated-icon" color="grey lighten-1" large>
            mdi-database-remove
          </v-icon>
        </v-col>
        <v-col class="d-flex align-center justify-center">
          <h3 class="body-1">No Data Available</h3>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Doughnut from "@/components/dashboard/charts/doughnut";

export default {
  components: {
    Doughnut,
  },
  props: {
    chartData: { type: Object, default: () => {}, required: true },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
          labels: {
            usePointStyle: true,
          },
        },
      },
      // chartData: {
      //   labels: ["Completed Reports", "Missed Reports", "Pending Reports"],
      //   datasets: [
      //     {
      //       backgroundColor: ["#6AC0E1", "#0978FA", "#72F0CF"],
      //       data: [4, 2, 6],
      //     },
      //   ],
      // },
    };
  },
  computed: {
    showChart() {
      const value = this.chartData.datasets.map((i) => i.data.some((v) => v));
      return value.includes(true);
    },
  },
  created() {},
};
</script>

<style scoped>
.chart-container {
  padding: 10px;
  max-height: 300px;
}
.no-data {
  height: 324px !important;
  width: 356px !important;
}
.animated-icon {
  animation: floatFade 3s ease-in-out infinite;
  transform-origin: center;
  opacity: 0.7;
}

@keyframes floatFade {
  0% {
    transform: translateY(0px);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
  100% {
    transform: translateY(0px);
    opacity: 0.7;
  }
}
</style>
